var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentWordsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 32.0837H21.875C29.1666 32.0837 32.0833 29.167 32.0833 21.8753V13.1253C32.0833 5.83366 29.1666 2.91699 21.875 2.91699H13.125C5.83329 2.91699 2.91663 5.83366 2.91663 13.1253V21.8753C2.91663 29.167 5.83329 32.0837 13.125 32.0837Z",
    stroke: "#1D2C49",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 13.125H12.0312",
    stroke: "#F4978E",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9688 21.875H12.0312",
    stroke: "#F4978E",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentWordsIcon);
export default __webpack_public_path__ + "static/media/document-words-icon.c433a84107ba39e599ae9c8581d97191.svg";
export { ForwardRef as ReactComponent };